import { Mail, MapPin, Phone, Sparkles } from "lucide-react";
import LeadForm from "@/components/forms/LeadForm";

export default function Contact() {
  return (
    <section
      id="contact"
      className="py-24 lg:py-32 px-6 lg:px-12 bg-[#FAF7F2] relative overflow-hidden"
      data-testid="contact-section"
    >
      <div className="blob blob-peach w-[360px] h-[360px] top-0 -left-20" />
      <div className="blob blob-teal w-[360px] h-[360px] bottom-0 -right-20" />

      <div className="relative mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Left info */}
        <div className="lg:col-span-5 bg-teal-700 text-white rounded-[2rem] p-8 lg:p-10 relative overflow-hidden">
          <span className="inline-flex items-center gap-2 bg-white/15 backdrop-blur px-3 py-1.5 rounded-full text-xs font-semibold mb-5">
            <Sparkles className="h-3.5 w-3.5 text-amber-300" />
            03 — Get a quote
          </span>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
            Let&apos;s draw your<br />
            <span className="italic font-medium text-amber-200">next plan.</span>
          </h2>
          <p className="text-teal-50/90 mt-5 leading-relaxed">
            Tell us about the property. We&apos;ll reply with a transparent quote
            and book the measurement within one business day.
          </p>
          <p className="mt-3 text-amber-200 font-semibold text-sm">
            We redraw plans from anywhere.
          </p>

          <div className="mt-10 space-y-5">
            <InfoRow
              icon={Mail}
              label="Email"
              value="hello@dmvfp.com"
              testId="contact-info-email"
              href="mailto:hello@dmvfp.com"
            />
            <InfoRow
              icon={Phone}
              label="Phone"
              value="(571) 331-8224"
              testId="contact-info-phone"
              href="tel:+15713318224"
            />
            <InfoRow
              icon={MapPin}
              label="Service Area"
              value="Washington DC · Maryland · Virginia"
              testId="contact-info-area"
            />
          </div>

          <div className="mt-10 pt-6 border-t border-white/20">
            <div className="text-[10px] tracking-[0.25em] uppercase text-teal-100/80 mb-2 font-semibold">
              Hours
            </div>
            <div className="text-sm text-teal-50">
              Mon – Sat · 8:00am – 5:00pm ET
              <br />
              Sunday by appointment
            </div>
          </div>

          <div className="absolute -right-16 -bottom-16 w-72 h-72 rounded-full bg-amber-300/30 blur-3xl pointer-events-none" />
        </div>

        {/* Right form */}
        <div className="lg:col-span-7 bg-white border border-stone-200 rounded-[2rem] p-8 lg:p-10 shadow-sm">
          <LeadForm />
        </div>
      </div>
    </section>
  );
}

function InfoRow({ icon: Icon, label, value, href, testId }) {
  const content = (
    <div className="flex items-start gap-4 group">
      <div className="h-11 w-11 rounded-full bg-white/15 backdrop-blur flex items-center justify-center group-hover:bg-white/25 transition-colors">
        <Icon className="h-4 w-4 text-amber-200" strokeWidth={2} />
      </div>
      <div>
        <div className="text-[10px] tracking-[0.25em] uppercase text-teal-100/80 font-semibold">
          {label}
        </div>
        <div className="text-white mt-0.5 font-medium">{value}</div>
      </div>
    </div>
  );
  return href ? (
    <a href={href} data-testid={testId} className="block">
      {content}
    </a>
  ) : (
    <div data-testid={testId}>{content}</div>
  );
}
